// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"156":"74df0175f770345522cb","318":"18274204f0e6a7ff53e3"}[chunkId] + ".js";
};